import { NavLink } from 'react-router-dom'
import React from 'react'

export const dagResync = classes => (
  <div className={'col-sm-12'}>
    <div className={`c-alert u-m-zero ${classes.alertPrimary} alert u-mb-medium`}>
      <div className="c-alert__content">
        <h4 className="c-alert__title">Dynamic Application Generation</h4>
        <p>
          Any changes on this page will require dynamic application to be re-synced. <br />
          <NavLink to={'/settings/dag/dynamic-apps'}>Re-Sync Dynamic Apps</NavLink>
        </p>
      </div>
    </div>
  </div>
)
